
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 42 45","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"42","height":"45"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.353.43h41.254v44.14H.353V.43z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32.89 32.424c-.527 1.78-2.1 3.682-4.933 3.682h-9.044l12.253-7.937a4.696 4.696 0 00-.905-.754l-6.753-4.375-14.68 9.51V12.452l21.928 14.202c2.377 1.54 2.66 3.991 2.134 5.77m2.475-12.873L18.914 8.896h9.043c2.833 0 4.406 1.901 4.933 3.681.354 1.195.338 2.691-.428 4.013l3.397 2.2a15.042 15.042 0 013.361 2.965c2.304-3.283 3.019-7.448 1.796-11.579C39.262 4.256 34.137.431 27.958.431H4.59c-.046 0-.09.005-.135.006v.005a4.238 4.238 0 00-1.888.501 4.234 4.234 0 00-2.214 3.72v35.675a4.234 4.234 0 004.235 4.232h23.369c6.18 0 11.305-3.824 13.059-9.744 1.753-5.92-.466-11.916-5.65-15.275","fill":"#000"}})])])
          )
        }
      }
    